<template>
  <SignaturePad
    :key="signStore.document?.signContext.defaultAutographUrl ?? ''"
    :has-default-autograph="true"
    :initial-signature-url="
      signStore.document?.signContext.defaultAutographUrl ?? undefined
    "
  />
</template>

<script setup lang="ts">
import SignaturePad from '@/components/signature/SignaturePad.vue';
import { useSignStore } from '@/stores/sign.ts';

const signStore = useSignStore();
</script>
